import { useTranslation } from 'react-i18next'

import { ChipInput } from '@reveni-io/reveni-ui'

import CategoriesSelector from '@/common/components/CategoriesSelector/CategoriesSelector'
import { productTaxonomyTypeOptions } from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/TryOnWidgetConfigurationPage/constants'

import { productTaxonomyIdsLabels } from './constants'

const ProductTaxonomyIdsField = ({
  productTaxonomyType,
  productTaxonomyDisplay,
  productTaxonomyIds,
  setProductTaxonomyIds,
  productCategories,
  productCollections,
}) => {
  const { t } = useTranslation()

  const label = t(productTaxonomyIdsLabels[productTaxonomyType][productTaxonomyDisplay])
  const categories =
    productTaxonomyType === productTaxonomyTypeOptions.collection ? productCollections : productCategories

  if (productTaxonomyType === productTaxonomyTypeOptions.tag) {
    return <ChipInput label={label} value={productTaxonomyIds} onChange={setProductTaxonomyIds} />
  }

  return (
    <CategoriesSelector
      categories={categories}
      value={productTaxonomyIds}
      onChange={setProductTaxonomyIds}
      placeholder=" "
      label={label}
    />
  )
}

export default ProductTaxonomyIdsField
